"use client"

import { useContext, useEffect } from "react"
import "./App.css"
import PrivateRoute from "./components/adminComponent/PrivateRoute"
import Cookies from "js-cookie"

import NavBar from "./components/navBar/NavBar.js"
import HomeDashboard from "./components/homeComponent/HomeComponent.js"
import InventaryComponent from "./components/itemComponent/InventaryComponent.js"
import CreateItemComponent from "./components/itemComponent/CreateItemComponent.js"
import CreateItemCategory from "./components/itemComponent/CreateItemCategory.js"

import GestionUbicacionComponent from "./components/adminComponent/GestionUbicacionComponent.js"
import GestionNegocioComponent from "./components/adminComponent/GestionNegocioComponent.js"
import GestionTipoEntidadComponent from "./components/adminComponent/GestionTipoEntidadComponent.js"
import GestionEntidadComponent from "./components/adminComponent/GestionEntidadComponent.js"
import CrearUsuarioComponent from "./components/adminComponent/CrearUsuarioComponent.js"
import GestionarAccesosComponent from "./components/adminComponent/GestionarAccesosComponent.js"
import TablaEntidadProveedor from "./components/adminComponent/TablaEntidadProveedor.js"
import GestionProveedoresComponent from "./components/adminComponent/GestionProveedoresComponent.js"
import TablaEntidadCliente from "./components/adminComponent/TablaEntidadCliente.js"

import GestionMonedaComponent from "./components/transaccionComponent/GestionMonedaComponent.js"
import GestionMedioPagoComponent from "./components/transaccionComponent/GestionMedioPagoComponent.js"
import GestionCategoriaTransaccionComponent from "./components/transaccionComponent/GestionCategoriaTransaccionComponent.js"
import GestionSubCategoriaTransaccionComponent from "./components/transaccionComponent/GestionSubCategoriaTransaccionComponent.js"
import GestionCategoriaYSubCategoria from "./components/transaccionComponent/GestionCategoriaYSubCategoria.js"
import GestionTipoTransaccionComponent from "./components/transaccionComponent/GestionTipoTransaccionComponent.js"
import GestionTransaccionComponent from "./components/transaccionComponent/GestionTransaccionComponent.js"
import GestionGastosComponent from "./components/transaccionComponent/GestionGastosComponent.js"
import TablaTransaccion from "./components/transaccionComponent/TablaTransaccionComponent.js"
import GestionGenerarVentaComponent from "./components/transaccionComponent/GestionGenerarVentaComponent.js"
import GestionDevolucionCanjeComponentVenta from "./components/transaccionComponent/GestionDevolucionCanjeVenta.js"
import TablaVentasComponent from "./components/transaccionComponent/TablaVentasComponent.js"
import GestionGenerarPresupuestoComponent from "./components/transaccionComponent/GestionGenerarPresupuestoComponent.js"
import TablaPresupuestoComponent from "./components/transaccionComponent/TablaPresupuestoComponent.js"
import GestionGenerarCompraComponent from "./components/transaccionComponent/GestionGenerarCompraComponent.js"
import TablaComprasComponent from "./components/transaccionComponent/TablaComprasComponent.js"
import TablaTransaccionComponent from "./components/transaccionComponent/TablaTransaccionComponent.js"
import TablaCuentaCorriente from "./components/transaccionComponent/TablaCuentaCorriente.js"
import ItemAtributoComponent from "./components/itemComponent/ItemAtributoComponent.js"
import GestionImpuestosComponent from "./components/transaccionComponent/GestionImpuestosComponent.js"
import CreateItemProveedor from "./components/itemComponent/CreateItemProveedor.js"
import TablaListaCosto from "./components/itemComponent/TableListaCosto.js"
import TablaListaPrecio from "./components/itemComponent/TableListaPrecio.js"
import EditarCompraComponent from "./components/transaccionComponent/EditarCompraComponent.js"
import TablaDetallesVentas from "./components/transaccionComponent/TablaDetallesVentas.js"
import TablaDetallesCompra from "./components/transaccionComponent/TablaDetallesCompra.js"
import TablaDetallesPresupuesto from "./components/transaccionComponent/TablaDetallesPresupuesto.js"
import RefreshRedirect from "./components/misc/RefreshRedirect.js"
import TablaVentasAfip from "./components/transaccionComponent/TablaVentasAfip.js"
import TablaVentasRetenciones from "./components/transaccionComponent/tablaVentasRetenciones.js"
import CajaComponentAnaliticos from "./components/adminComponent/CajaComponentAnaliticos.js"
import CajaComponent from "./components/transaccionComponent/CajaComponent.js"
import RecetaComponent from "./components/itemComponent/RecetaComponent.js"
import TablaReceta from "./components/itemComponent/TablaReceta.js"
import TablaVerBalance from "./components/itemComponent/TablaVerBalance.js"
import NoTienesAccesosComponent from "./components/adminComponent/noTienesAccesosComponent.js"
import TablaGastosComponent from "./components/transaccionComponent/TablaGastosComponent.js"
import TablaVentasEstados from "./components/transaccionComponent/TablaVentasEstados.js"
import SessionExpiredModal from "./components/adminComponent/SessionExpiredModal.js"
import CreateServicioComponent from "./components/itemComponent/CreateServicioComponent.js"
import LoginComponent from "./components/adminComponent/LoginComponent.js"
import GestionDestinosViajes from "./components/adminComponent/GestionDestinosViajes.js"
import InventaryServiciosComponent from "./components/itemComponent/InventaryServiciosComponent.js"
import CrearCliente from "./components/adminComponent/CrearCliente.js"
import CrearProveedor from "./components/adminComponent/CrearProveedor.js"
import AsociarClientesPaquete from "./components/transaccionComponent/GestionGenerarClientesPaquete.js"
import GestionClientesTabs from "./components/adminComponent/GestionClientesTabs.js"

// Portal de Clientes
import ClienteLoginComponent from "./components/clientePortal/ClienteLoginComponent.js"
import ClienteDashboard from "./components/clientePortal/ClienteDashboard.js"
import ClienteCuotasDetalle from "./components/clientePortal/ClienteCuotasDetalle.js"
import ClientePortalRedirect from "./components/clientePortal/ClientePortalRedirect.js"
import ClienteProtectedRoute from "./components/clientePortal/ClienteProtectedRoute.js"
import ClientePagoResultado from "./components/clientePortal/ClientePagoResultado.js"

import { ErpContext } from "./context/ErpContext.js"
import { ThemeProvider } from "@mui/material/styles"

import theme from "./muiThemes/Themes.js"

import { Route, Routes, Navigate } from "react-router-dom"

import { useLocation } from "react-router-dom"

// Función para verificar si el usuario tiene acceso a un menú específico
const tieneAcceso = (menuId, accesos) => {
  return accesos?.some((a) => a.idMenuAcceso === menuId && a.eliminado === false)
}

// Componente para proteger rutas basado en accesos
const ProtectedRoute = ({ children, requiredAccess }) => {
  const { user } = useContext(ErpContext)

  if (!user) {
    const tenantURL = Cookies.get("tenantURL") || "default";
    return <Navigate to={`/${tenantURL}/login`} replace />;
  }

  const userAccesses = user?.accesos || []

  // Si no se especifica acceso requerido, permitir acceso
  if (!requiredAccess) {
    return children
  }

  // Verificar si el usuario tiene el acceso requerido
  if (tieneAcceso(requiredAccess, userAccesses)) {
    return children
  }

  // Si no tiene acceso, mostrar componente de acceso denegado
  return <NoTienesAccesosComponent />
}

function App() {
  const { user, isNavbarCollapsed, isSessionExpired } = useContext(ErpContext)
  const location = useLocation()
  
  // Verificar si estamos en el portal de clientes (no mostrar NavBar)
  const isClientePortal = location.pathname.includes('/mispagos');
  const clienteToken = localStorage.getItem('clienteToken');

  useEffect(() => {
    console.log(location.pathname)

    const managerDiv = document.querySelector(".ManagerDiv")

    if (managerDiv) {
      managerDiv.style.marginBottom = "0px"
    }
    console.log("user ", user)
  }, [location.pathname])

  return (
    <ThemeProvider theme={theme}>
      <div className="bodySimulator">
        {/* 🔒 Modal de sesión expirada - bloqueante y global */}
        <SessionExpiredModal />
        
        {/* NO mostrar NavBar en el portal de clientes */}
        {user && !isClientePortal && <NavBar />}
        <div 
          className="containerManagerDiv"
          style={{ 
            pointerEvents: isSessionExpired ? 'none' : 'auto',
            opacity: isSessionExpired ? 0.5 : 1,
            transition: 'opacity 0.3s ease',
          }}
        >
          <div className="ManagerDiv">
            <Routes>
              <Route path=":tenant/login" element={user ? <Navigate to="/" /> : <LoginComponent />} />

              {/* PORTAL DE CLIENTES - RUTAS PÚBLICAS (INDEPENDIENTES DEL SISTEMA ADMIN) */}
              {/* Ruta raíz: redirige a login o dashboard según token */}
              <Route path=":tenant/mispagos" element={<ClientePortalRedirect />} />
              
              {/* Login público - NO requiere sesión admin */}
              <Route path=":tenant/mispagos/login" element={<ClienteLoginComponent />} />
              
              {/* Rutas protegidas del portal - Requieren token de cliente, NO admin */}
              <Route 
                path=":tenant/mispagos/dashboard" 
                element={
                  <ClienteProtectedRoute>
                    <ClienteDashboard />
                  </ClienteProtectedRoute>
                } 
              />
              <Route 
                path=":tenant/mispagos/cuotas/:idItem/:idUbicacion" 
                element={
                  <ClienteProtectedRoute>
                    <ClienteCuotasDetalle />
                  </ClienteProtectedRoute>
                }
              />
              
              {/* Página de resultado de pago - Protegida */}
              <Route 
                path=":tenant/mispagos/pago-resultado" 
                element={
                  <ClienteProtectedRoute>
                    <ClientePagoResultado />
                  </ClienteProtectedRoute>
                }
              />

              {/* RUTAS PROTEGIDAS */}
              <Route path=":tenant" element={<PrivateRoute />}>
                {/* DASHBOARD */}
                <Route
                  path=""
                  element={
                    <ProtectedRoute requiredAccess="DASHBOARD">
                      <HomeDashboard />
                    </ProtectedRoute>
                  }
                />

                {/* RUTAS DE INVENTARIO */}
                <Route
                  path="verGrupos"
                  element={
                    <ProtectedRoute requiredAccess="INVENTARIO3">
                      <InventaryComponent />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="crearItem"
                  element={
                    <ProtectedRoute requiredAccess="INVENTARIO1">
                      <CreateItemComponent />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="crearServicio"
                  element={
                    <ProtectedRoute requiredAccess="INVENTARIO7">
                      <CreateServicioComponent />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="verServicios"
                  element={
                    <ProtectedRoute requiredAccess="COMPRAS8">
                      <InventaryServiciosComponent />
                    </ProtectedRoute>
                  }
                />
                <Route path="crearItemCategoria" element={<CreateItemCategory />} />
                <Route
                  path="Atributos"
                  element={
                    <ProtectedRoute requiredAccess="INVENTARIO4">
                      <ItemAtributoComponent />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="itemProveedor"
                  element={
                    <ProtectedRoute requiredAccess="INVENTARIO1">
                      <CreateItemProveedor />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="tablaListaCosto"
                  element={
                    <ProtectedRoute requiredAccess="COMPRAS5">
                      <TablaListaCosto />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="tablaListaPrecio"
                  element={
                    <ProtectedRoute requiredAccess="VENTAS8">
                      <TablaListaPrecio />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="recetaComponent"
                  element={
                    <ProtectedRoute requiredAccess="INVENTARIO2">
                      <RecetaComponent />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="tablaReceta"
                  element={
                    <ProtectedRoute requiredAccess="INVENTARIO5">
                      <TablaReceta />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="verDestinos"
                  element={
                    <ProtectedRoute requiredAccess="INVENTARIO6">
                      <GestionDestinosViajes />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="verBalance"
                  element={
                    <ProtectedRoute requiredAccess="INVENTARIO8">
                      <TablaVerBalance />
                    </ProtectedRoute>
                  }
                />


                {/* RUTAS DE VENTAS */}
                <Route
                  path="gestionGenerarVenta/:id?"
                  element={
                    <ProtectedRoute requiredAccess="VENTAS1">
                      <GestionGenerarVentaComponent />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="tablaVentas"
                  element={
                    <ProtectedRoute requiredAccess="VENTAS2">
                      <TablaVentasComponent />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="tablaVentasEstados"
                  element={
                    <ProtectedRoute requiredAccess="VENTAS9">
                      <TablaVentasEstados />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="gestionGenerarPresupuesto/:id?"
                  element={
                    <ProtectedRoute requiredAccess="VENTAS3">
                      <GestionGenerarPresupuestoComponent />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="tablaPresupuesto"
                  element={
                    <ProtectedRoute requiredAccess="VENTAS4">
                      <TablaPresupuestoComponent />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="verVentasDetalle"
                  element={
                    <ProtectedRoute requiredAccess="VENTAS5">
                      <TablaDetallesVentas />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="verPresupuestoDetalle"
                  element={
                    <ProtectedRoute requiredAccess="VENTAS6">
                      <TablaDetallesPresupuesto />
                    </ProtectedRoute>
                  }
                />

                {/* RUTAS DE CLIENTES */}
                <Route
                  path="crearCliente"
                  element={
                    <ProtectedRoute requiredAccess="CLIENTES1">
                      <CrearCliente />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="gestionCliente"
                  element={
                    <ProtectedRoute requiredAccess="CLIENTES2">
                      <TablaEntidadCliente />
                    </ProtectedRoute>
                  }
                />
                  <Route
                    path="asociarClientesPaquete"
                    element={
                      <ProtectedRoute requiredAccess="CLIENTES4">
                        <AsociarClientesPaquete />
                      </ProtectedRoute>
                    }
                  />
                <Route
                  path="clientePaqueteDetalle"
                  element={
                    <ProtectedRoute requiredAccess="CLIENTES3">
                      <GestionClientesTabs />
                    </ProtectedRoute>
                  }
                />

                {/* RUTAS DE COMPRAS */}
                <Route
                  path="crearCompra"
                  element={
                    <ProtectedRoute requiredAccess="COMPRAS1">
                      <GestionGenerarCompraComponent />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="tablaCompra"
                  element={
                    <ProtectedRoute requiredAccess="COMPRAS2">
                      <TablaComprasComponent />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="verCompraDetalle"
                  element={
                    <ProtectedRoute requiredAccess="COMPRAS3">
                      <TablaDetallesCompra />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="TablaEntidadProveedor"
                  element={
                    <ProtectedRoute requiredAccess="COMPRAS4">
                      <TablaEntidadProveedor />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="gestionProveedoresComponent"
                  element={
                    <ProtectedRoute requiredAccess="COMPRAS4">
                      <GestionProveedoresComponent />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="editarCompraComponent/:idTransaccionEditarCompra/:idEstado"
                  element={
                    <ProtectedRoute requiredAccess="COMPRAS2">
                      <EditarCompraComponent />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="crearProveedor"
                  element={
                    <ProtectedRoute requiredAccess="COMPRAS6">
                      <CrearProveedor />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="tablaGastosComponent"
                  element={
                    <ProtectedRoute requiredAccess="COMPRAS7">
                      <TablaGastosComponent />
                    </ProtectedRoute>
                  }
                />

                {/* RUTAS DE ADMINISTRACIÓN */}

                <Route
                  path="gestionTipoTransaccion"
                  element={
                    <ProtectedRoute requiredAccess="ADMINISTRACION10">
                      <GestionTipoTransaccionComponent />
                    </ProtectedRoute>
                  }
                />
                {/* <Route
                  path="gestionTransaccionComponent"
                  element={
                    <ProtectedRoute requiredAccess="TRANSACCIONES3">
                      <GestionTransaccionComponent />
                    </ProtectedRoute>
                  }
                /> */}
                <Route
                  path="gestionGastosComponent"
                  element={
                    <ProtectedRoute requiredAccess="TRANSACCIONES4">
                      <GestionGastosComponent />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="tablaTransaccionComponent"
                  element={
                    <ProtectedRoute requiredAccess="TRANSACCIONES5">
                      <TablaTransaccionComponent />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="tablaCuentaCorriente"
                  element={
                    <ProtectedRoute requiredAccess="TRANSACCIONES6">
                      <TablaCuentaCorriente />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="tablaVentasAfip"
                  element={
                    <ProtectedRoute requiredAccess="TRANSACCIONES7">
                      <TablaVentasAfip />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="tablaVentasRetenciones"
                  element={
                    <ProtectedRoute requiredAccess="TRANSACCIONES11">
                      <TablaVentasRetenciones />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="cajaComponentAnaliticos"
                  element={
                    <ProtectedRoute requiredAccess="TRANSACCIONES8">
                      <CajaComponentAnaliticos />
                    </ProtectedRoute>
                  }
                />
                {/* <Route
                  path="tablaGastosComponent"
                  element={
                    <ProtectedRoute requiredAccess="TRANSACCIONES9">
                      <TablaGastosComponent />
                    </ProtectedRoute>
                  }
                /> */}
                <Route
                  path="CajaComponent"
                  element={
                    <ProtectedRoute requiredAccess="TRANSACCIONES10">
                      <CajaComponent />
                    </ProtectedRoute>
                  }
                />

                {/* RUTAS DE CONFIGURACION */}
                <Route
                  path="gestionMoneda"
                  element={
                    <ProtectedRoute requiredAccess="ADMINISTRACION1">
                      <GestionMonedaComponent />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="Impuestos"
                  element={
                    <ProtectedRoute requiredAccess="ADMINISTRACION2">
                      <GestionImpuestosComponent />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="gestionCategoria"
                  element={
                    <ProtectedRoute requiredAccess="ADMINISTRACION3">
                      <GestionCategoriaYSubCategoria />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="gestionSubCategoria"
                  element={
                    <ProtectedRoute requiredAccess="ADMINISTRACION4">
                      <GestionSubCategoriaTransaccionComponent />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="gestionUbicaciones"
                  element={
                    <ProtectedRoute requiredAccess="ADMINISTRACION5">
                      <GestionUbicacionComponent />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="gestionEntidad"
                  element={
                    <ProtectedRoute requiredAccess="ADMINISTRACION6">
                      <GestionEntidadComponent />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="gestionUsuarios"
                  element={
                    <ProtectedRoute requiredAccess="ADMINISTRACION7">
                      <CrearUsuarioComponent />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="gestionarAccesos"
                  element={
                    <ProtectedRoute requiredAccess="ADMINISTRACION8">
                      <GestionarAccesosComponent />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="gestionMedioPago"
                  element={
                    <ProtectedRoute requiredAccess="ADMINISTRACION9">
                      <GestionMedioPagoComponent />
                    </ProtectedRoute>
                  }
                />

                {/* RUTAS ESPECIALES */}
                <Route
                  path="gestionDevolucionVenta/:idTransaccionDatosDevolucion?"
                  element={
                    <ProtectedRoute requiredAccess="VENTAS2">
                      <GestionDevolucionCanjeComponentVenta />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="transacciones"
                  element={
                    <ProtectedRoute requiredAccess="TRANSACCIONES5">
                      <TablaTransaccion />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="RefreshRedirect/:idTransaccionEditarCompra/:idEstado"
                  element={
                    <ProtectedRoute requiredAccess="COMPRAS2">
                      <RefreshRedirect />
                    </ProtectedRoute>
                  }
                />

                {/* RUTAS SIN PROTECCIÓN ESPECÍFICA */}
                <Route path="gestionNegocio" element={<GestionNegocioComponent />} />
                <Route path="gestionTipoEntidad" element={<GestionTipoEntidadComponent />} />
              </Route>
            </Routes>
          </div>
        </div>
      </div>
    </ThemeProvider>
  )
}

export default App
